import React, { useState, useEffect, FC, useCallback } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Content from "../../layout/content/Content";
import {
  Card,
  Badge,
  Row,
  Collapse,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  InputSwitch,
  TooltipComponent,
} from "../../components/Component";
import {
  Controller,
  FormProvider,
  useFieldArray,
  useForm,
  useFormContext,
} from "react-hook-form";
import {
  PaperClipOutlined,
  DownloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Form,
  TableColumnsType,
  Input,
  InputNumber,
  Popconfirm,
  Table,
  Typography,
  Select,
  Divider,
  Space,
  Timeline,
  Collapse as AntCollapse,
  Button as AntButton,
  Descriptions,
  List,
  Modal as AntModal,
  Empty,
  Flex,
  Spin,
  DatePicker,
  Popover,
} from "antd";
import Swal from "sweetalert2";
import { columnData } from "../app/kanban/KanbanData";
import inventoryCreation from "../../api/inventory/inventoryCreation";
import dayjs from "dayjs";
import { set } from "date-fns";
import CropperComponent from "../components/CropperComponent";
import SignatureModal from "../purchase-orders/SignatureModal";
import rolesApi from "../../api/master/roles";
import ImageUploadCropper from "../components/ImageUploadCropper";
import { MaterialTaskPanel } from "./MaterialTaskPanel";
import MaterialIssuePDF from "./MaterialIssuePDF";
const { Panel } = AntCollapse;

const MaterialDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sm, setSm] = useState(false);
  const [tab, setTab] = useState("1");
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSubmitBtm, setShowSubmitBtm] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [data, setData] = useState([]);
  const [signature, setSignature] = useState<any>({});
  const [detailsData, setDetailsData] = useState<any>();
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const location = useLocation();
  const screenNavigationStatus = location.state?.screenStatus;
  const [roles, setRoles] = useState<any>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const [approveRecord, setApproveRecord] = useState<any>(null);
  const [rejectRecord, setRejectRecord] = useState<any>(null);
  const [isModalApproveVisible, setIsModalApproveVisible] = useState(false);
  const [isModalRejectedVisible, setIsModalRejectedVisible] = useState(false);

  const [rejectForm] = Form.useForm();
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [currentUserId, setCurrentUserId] = useState<any>(null);
  const [approverIds, setApproverIds] = useState<any>([]);
  const [isStrictMode, setIsStrictMode] = useState<boolean>(false);
  const [approveSignature, setApproveSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });
  const [rejectSignature, setRejectSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });
  const [activeSignatureContext, setActiveSignatureContext] = useState<
    "APPROVE" | "REJECT" | null
  >(null);
  const [disableApprove, setDisableApprove] = useState(false);
  const [disableReject, setDisableReject] = useState(false);

  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;
  const previousStatePath = location.state;
  const columnData = [
    {
      title: "Material Category",
      dataIndex: "categoryName",
      key: "categoryName",
      width: 200,
    },
    {
      title: "Material Name",
      dataIndex: "materialName",
      key: "materialName",
      width: 200,
    },
    {
      title: "UOM",
      dataIndex: "uomName",
      key: "uomName",
      width: 200,
    },
    {
      title: "Issued Quantity",
      dataIndex: "quantityIssued",
      key: "quantityIssued",
      width: 200,
      render: (text: number, record: any) => (
        <div>
          <span>{text.toLocaleString("en-IN")}</span>
        </div>
      ),
    },
    {
      title: "HandOver Status",
      dataIndex: "handoverStatus",
      key: "handoverStatus",
      width: 200,
      render: (text: any) =>
        text || detailsData?.header?.handoverStatus || "--",
    },
    {
      title: "HandOvered Quantity",
      dataIndex: "quantityHandovered",
      key: "quantityHandovered",
      width: 200,
    },
    // {
    //   title: "Qty Available For Utilization",
    //   dataIndex: "quanitityAvailable",
    //   key: "quanitityAvailable",
    //   width: 200,
    //   render: (text: number, record: any) => (
    //     <div>
    //       <span>{text.toLocaleString("en-IN")}</span>
    //     </div>
    //   ),
    // },
  ];

  const fetchApprovalHierarchyUsersByModuleId = async (moduleID: number, siteId: number) => {
    // console.log("formData.site", formData.budgetHeader.site)
    try {
      const res = await rolesApi.fetchHierarchyUsersByModuleId(
        moduleID,
        Number(detailsData?.header?.siteId)
      );
      if (!res) return;
      const { data, status } = res;
      if (status) {
        setRoles(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchModuleConfig();
  }, []);

  const fetchModuleConfig = async () => {
    try {
      const res = await rolesApi.getModuleConfig();
      let moduleID: number | undefined;

      // Find the Inventory category first
      const procureToPayCategory = res?.data?.find(
        (category: any) => category.category === "Inventory"
      );

      if (procureToPayCategory && procureToPayCategory.modules) {
        // Find the Material Issue module
        const purchaseOrderModule = procureToPayCategory.modules.find(
          (module: any) => module.moduleName === "Material Issue"
        );

        if (purchaseOrderModule) {
          moduleID = purchaseOrderModule.moduleID;
        }
      }

      if (moduleID && detailsData?.header?.siteId) {
        await fetchApprovalHierarchyUsersByModuleId(moduleID, Number(detailsData?.header?.siteId));
      } else {
        console.warn("Module ID or Site ID is missing", {
          moduleID,
          siteId: detailsData?.header?.siteId
        });
        setRoles([]);
      }
    } catch (err) {
      console.error("Error fetching module config:", err);
      setRoles([]);
    }
  };

  useEffect(() => {
    if (id) {
      fetchMaterialDetails(id);
    }
  }, []);

  useEffect(() => {
    if (currentUser) {
      const { id } = currentUser;
      setCurrentUserId(id);
    }
  }, [currentUser]);

  const fetchMaterialDetails = async (id: any) => {
    const response = await inventoryCreation.fetchViewMaterialDetails(id);
    const { response: _response, status } = response;
    if (status) {
      const data = _response.data;
      const isStrict = data?.header?.isStrictApproval === true || data?.header?.isStrictApproval === 1;
      setIsStrictMode(isStrict);
      setDetailsData(data);

      if (data?.approvals) {
        const processedApprovals = data.approvals.map((approval: any) => ({
          ...approval,
          level: approval.level?.toLowerCase() || approval.level,
          status: approval.status?.toLowerCase() || approval.status
        }));

        // Filter pending approvals
        let ids = processedApprovals
          ?.filter((item: any) => item?.status?.toLowerCase() !== "approved")
          ?.map((item: any) => item?.userId);
        setApproverIds(ids);
      }
    }
  };

  const parseLevelNum = (level: any) => {
    if (!level && level !== 0) return NaN;
    const str = String(level).toLowerCase();

    // Handle various level formats: level1, Level2, L1, L2, etc.
    if (str.includes('level')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    } else if (str.startsWith('l')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    }
    return NaN;
  };

  const hasUserAlreadyApproved = detailsData?.approvals?.some(
    (a: any) =>
      a.userId === currentUserId &&
      a.status?.toUpperCase() === "APPROVED"
  );

  const canUserApproveReject = useCallback(() => {
    // 1. Admin can Approve/Reject anytime - Buttons are always ENABLED
    if (currentUser?.genericRole?.toLowerCase() === "admin") {
      return true;
    }

    const approvals = detailsData?.approvals || [];

    // Find current user's approval entry
    const userApproval = approvals.find(
      (approval: any) => approval.userId === currentUserId
    );

    if (!userApproval || userApproval.status?.toLowerCase() !== "pending") {
      return false;
    }

    const userLevelNum = parseLevelNum(userApproval.level ?? currentUser?.approvalLevel);

    // 2. Strict = 0 (Flexible mode)
    // Anyone in the approval list can approve at any time
    if (isStrictMode === false) {
      // In flexible mode, just check if user is in the approval list and pending
      return true;
    }

    // 3. Strict = 1 (Sequential mode)
    // Must follow the order. Level 2 cannot see buttons until Level 1 is "Approved"
    if (isStrictMode === true) {
      // Get all pending approvals sorted by level
      const pendingApprovals = approvals
        .filter((approval: any) => approval.status?.toLowerCase() === "pending")
        .sort((a: any, b: any) => {
          const aNum = parseLevelNum(a.level);
          const bNum = parseLevelNum(b.level);
          if (isNaN(aNum) || isNaN(bNum)) return 0;
          return aNum - bNum;
        });

      // If there are no pending approvals, user can't approve
      if (pendingApprovals.length === 0) return false;

      // Get the first pending approval (lowest level)
      const firstPending = pendingApprovals[0];
      const firstPendingLevelNum = parseLevelNum(firstPending.level);

      // Check if user is the first pending approver
      return userApproval.userId === firstPending.userId &&
        userLevelNum === firstPendingLevelNum;
    }

    return false;
  }, [currentUser, currentUserId, detailsData?.approvals, isStrictMode]);

  const getPendingStatusMessage = () => {
    const approvals = detailsData?.approvals || [];
    const pendingApprovals = approvals
      .filter((approval: any) => approval.status?.toLowerCase() === "pending")
      .sort((a: any, b: any) => {
        const aNum = parseLevelNum(a.level);
        const bNum = parseLevelNum(b.level);
        if (isNaN(aNum) || isNaN(bNum)) return 0;
        return aNum - bNum;
      });

    if (pendingApprovals?.length > 0) {
      if (!isStrictMode) {
        // Flexible mode - any approver can approve
        const approverNames = pendingApprovals.map((approval: any) => approval.userName).join(", ");
        return `Status is pending. Any of these approvers can approve: ${approverNames}`;
      } else {
        // Strict mode - must follow sequence
        const nextApprover = pendingApprovals[0];
        const lvl = parseLevelNum(nextApprover.level);
        const levelText = !isNaN(lvl) ? `Level ${lvl}` : nextApprover.roleName || "";
        return `Status is pending. Waiting for ${nextApprover.userName} (${levelText}) to approve first.`;
      }
    }

    return "Status is pending by other approvers";
  };

  const ApprovalTimelineContent = () => {
    if (
      !detailsData?.approvals ||
      detailsData?.approvals?.length === 0 ||
      detailsData?.header?.approvalRequired == "N"
    )
      return <Badge color="outline-danger">No</Badge>;

    return (
      <Popover
        content={
          <Timeline className="approval-timeline">
            {detailsData?.approvals?.map((approval: any, index: number) => {
              const isApproved = approval.status?.toLowerCase() === "approved";
              const isRejected = approval.status?.toLowerCase() === "rejected";

              return (
                <Timeline.Item
                  key={index}
                  dot={
                    isApproved ? (
                      <CheckCircleOutlined style={{ color: "green" }} />
                    ) : isRejected ? (
                      <CloseCircleOutlined style={{ color: "red" }} />
                    ) : undefined
                  }
                >
                  {approval?.userName || "Unknown User"}
                  <div className="designation">{approval?.roleName || "Unknown Role"}</div>
                  {approval?.approvalDate && (
                    <div className="designation">
                      {dayjs(approval?.approvalDate).format("DD-MMM-YYYY")}
                    </div>
                  )}
                </Timeline.Item>
              );
            })}
          </Timeline>
        }
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer"
        }}>
          <span
            style={{
              color: "#2263b3",
            }}
          >
            <Badge color="outline-success">Yes</Badge>
          </span>
          {isStrictMode && (
            <Badge
              color="warning"
              style={{
                fontSize: "11px",
                cursor: "pointer",
                marginLeft: "4px"
              }}
              title="Sequential approvals required, Approvals must follow the sequence"
            >
              Strict
            </Badge>
          )}
        </div>
      </Popover>
    );
  };

  const submitSave = () => { };

  const dataURLToFile = (dataUrl: string, fileName: string): File => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };

  // Handle approve with signature
  const handleApproveWithSignature = async () => {
    if (!approveSignature.image) {
      Swal.fire({
        icon: "info",
        title: "Signature Required",
        text: "Please add your signature before approving.",
      });
      setDisableApprove(false);
      return;
    }

    setIsModalApproveVisible(false);

    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "No, keep it",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const file = dataURLToFile(approveSignature.image as string, "signature.png");
          const res = await inventoryCreation.approve(Number(id), [file]);
          const { status, message } = res;

          if (status) {
            Swal.fire("Approved!", message || "Material issue approved successfully", "success");
            fetchMaterialDetails(id);
            navigate(
              previousStatePath?.previousPath
                ? previousStatePath?.previousPath
                : screenNavigationStatus === "Pending Material Issue Approvals"
                  ? "/materialIssue-pending-approvals"
                  : "/material-issue"
            );
          } else {
            Swal.fire("Error!", message || "Failed to approve material issue", "error");
          }
        } catch (error) {
          console.log(error);
          Swal.fire("Error!", "Something went wrong while approving", "error");
        }
      } else {
        setIsModalApproveVisible(true);
        setDisableApprove(false);
      }
    });
  };

  // Handle reject with signature
  const handleRejectWithSignature = (reason: string) => {
    if (!rejectSignature.image) {
      Swal.fire({
        icon: "info",
        title: "Signature Required",
        text: "Please add your signature before rejecting.",
      });
      setDisableReject(false);
      return;
    }

    setIsModalRejectedVisible(false);

    Swal.fire({
      title: "Confirm Rejection?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const file = dataURLToFile(rejectSignature.image as string, "signature.png");
          const res = await inventoryCreation.reject(Number(id), reason, [file]);
          const { status, message } = res;

          if (status) {
            Swal.fire("Rejected!", message || "Material issue rejected successfully", "success");
            fetchMaterialDetails(id);
            navigate(
              previousStatePath?.previousPath
                ? previousStatePath?.previousPath
                : screenNavigationStatus === "Pending Material Issue Approvals"
                  ? "/materialIssue-pending-approvals"
                  : "/material-issue"
            );
            rejectForm.resetFields();
            setRejectSignature({ isActive: false, label: "Authorised Signatory", image: null });
          } else {
            Swal.fire("Error!", message || "Failed to reject material issue", "error");
          }
        } catch (error) {
          console.log(error);
          Swal.fire("Error!", "Something went wrong while rejecting", "error");
        }
      } else {
        setIsModalRejectedVisible(true);
        setDisableReject(false);
      }
    });
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      // Assuming `record.headerId` is used to identify the purchase order
      const payload = {
        materialIssueId: id,
        reason: values.reason,
      };

      // Call the API to submit the rejection
      await apiCallToRejectBudget(id, values.reason);

      // Handle success (e.g., show a success message, refresh the table)

      setIsModalVisible(false);
      form.resetFields();
    } catch (error) {
      // Handle validation errors or API errors
    }
  };

  const apiCallToRejectBudget = async (issueNumber: any, reason: string) => {
    // Replace this with your actual API call logic
    try {
      const res = await inventoryCreation.reject(issueNumber,
        reason,
      );
      const { response, status, message } = res;
      console.log("data", res);
      if (status) {
        Swal.fire("Rejected!", "Rejected", "success");
        navigate(-1);
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };


  const materialIssueDataForPDF = () => {
    return {
      header: detailsData?.header,
      lines: detailsData?.lines,
      approvals: detailsData?.approvals,
      orgName: detailsData?.orgName || "",
      orgAddress: detailsData?.orgAddress || "",
      orgCIN: detailsData?.orgCIN || "",
      orgGSTIN: detailsData?.orgGSTIN || "",
    };
  };

  return (
    <>
      <Head title="Material Issue Details" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {isLoading == true ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <div className="card-inner card-inner-lg">
                {sm && mobileView && (
                  <div
                    className="toggle-overlay"
                    onClick={() => setSm(!sm)}
                  ></div>
                )}
                <BlockHead size="lg">
                  <BlockBetween>
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        <span>
                          Material Issue # - {detailsData?.header?.issueNumber}{" "}
                          | {detailsData?.header?.issueStatus}
                          {/* {(statusMapper[rfqStatus] &&
                              statusMapper[rfqStatus]?.buyer?.title) ||
                              rfqStatus}{" "} */}
                        </span>
                      </BlockTitle>
                    </BlockHeadContent>
                    <div className="d-flex">
                      {showSubmitBtm && (
                        <div className="actions clearfix">
                          <ul
                            className="m-auto d-flex align-items-center justify-content-center p-0"
                            style={{
                              flexDirection: "row-reverse",
                            }}
                          >
                            <li className="pt-0 pb-0">
                              {disableSubmit ? (
                                <Button color="primary" type="button">
                                  <Spinner size="sm" color="light" />
                                </Button>
                              ) : (
                                <Button
                                  color="primary"
                                  type="button"
                                  onClick={() => {
                                    setDisableSubmit(true);
                                    Swal.fire({
                                      title: "Are you sure?",
                                      text: "Do you want to submit the changes?",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Yes, submit it!",
                                      cancelButtonText: "No, cancel",
                                    }).then(async (result) => {
                                      if (result.isConfirmed) {
                                        await submitSave();
                                      } else {
                                        setDisableSubmit(false);
                                      }
                                    });
                                  }}
                                >
                                  Submit
                                </Button>
                              )}
                            </li>
                          </ul>
                        </div>
                      )}

                      {!showSubmitBtm && (
                        <div className="paddingLeft10">
                          <Button
                            className="toggle"
                            color="primary"
                            onClick={async () => {
                              navigate(
                                previousStatePath?.previousPath
                                  ? previousStatePath?.previousPath
                                  : screenNavigationStatus ===
                                    "Pending Material Issue Approvals"
                                    ? "/materialIssue-pending-approvals"
                                    : "/material-issue"
                              );
                            }}
                          >
                            <Icon name="arrow-left" />
                            <span>Back</span>
                          </Button>
                        </div>
                      )}

                      {/* PDF Button */}
                      <div className="paddingLeft10">
                        <MaterialIssuePDF
                          materialIssueData={materialIssueDataForPDF()}
                          buyerOrgLogo={currentUser?.orgLogo}
                        />
                      </div>

                      {detailsData?.header?.issueStatus?.toLowerCase() === "pending" &&
                        !hasUserAlreadyApproved && (
                          <ul className="nk-tb-actions ms-2">
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  tag="a"
                                  className="dropdown-toggle btn btn-icon btn-trigger"
                                >
                                  <Icon name="more-v"></Icon>
                                </DropdownToggle>
                                <DropdownMenu end>
                                  <ul className="link-list-opt no-bdr">
                                    {/* {detailsData?.header?.issueStatus?.toLowerCase() === "pending" &&
                                  !hasUserAlreadyApproved && ( */}
                                    <>
                                      {canUserApproveReject() ? (
                                        <>
                                          <li
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setApproveRecord(id);
                                              setActiveSignatureContext("APPROVE");
                                              setIsModalApproveVisible(true);
                                              const dropdown = document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                              if (dropdown) {
                                                dropdown.classList.remove("show");
                                              }
                                            }}
                                          >
                                            <Link to={`#`}>
                                              <Icon name="check" /> Approve
                                            </Link>
                                          </li>
                                          <li
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setRejectRecord(id);
                                              setActiveSignatureContext("REJECT");
                                              setIsModalRejectedVisible(true);
                                              const dropdown = document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                              if (dropdown) {
                                                dropdown.classList.remove("show");
                                              }
                                            }}
                                          >
                                            <Link to={`#`}>
                                              <Icon name="cross" /> Reject
                                            </Link>
                                          </li>
                                        </>
                                      ) : (
                                        <>
                                          <li className="disabled" style={{ position: 'relative' }}>
                                            <div
                                              className="d-flex align-items-center justify-content-between w-100"
                                              style={{
                                                padding: "8px 16px",
                                                opacity: 0.6,
                                                cursor: "not-allowed",
                                              }}
                                            >
                                              <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                                <Icon name="check" />
                                                <span>Approve</span>
                                              </div>
                                              <Popover
                                                content={
                                                  <div style={{ padding: "8px", maxWidth: "300px" }}>
                                                    <p style={{ margin: 0 }}>{getPendingStatusMessage()}</p>
                                                  </div>
                                                }
                                                title="Approval Status"
                                                trigger="hover"
                                              >
                                                <InfoCircleOutlined
                                                  style={{
                                                    fontSize: "16px",
                                                    cursor: "pointer",
                                                    color: "#2263b3",
                                                    marginLeft: "8px"
                                                  }}
                                                />
                                              </Popover>
                                            </div>
                                          </li>
                                          <li className="disabled">
                                            <div
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "8px 16px",
                                                opacity: 0.6,
                                                cursor: "not-allowed",
                                                gap: "8px"
                                              }}
                                            >
                                              <Icon name="cross" />
                                              <span>Reject</span>
                                            </div>
                                          </li>
                                        </>
                                      )}
                                    </>
                                    {/* )} */}
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        )}
                    </div>
                    <BlockHeadContent className="align-self-start d-lg-none">
                      <Button
                        className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""
                          }`}
                        onClick={() => setSm(!sm)}
                      >
                        <Icon name="menu-alt-r" />
                      </Button>
                    </BlockHeadContent>
                  </BlockBetween>
                </BlockHead>
                <div className="content clearfix">
                  <AntCollapse defaultActiveKey={["1", "2"]}>
                    <Panel header="General Information" key="1">
                      <div>
                        <Col className="justify-start w-100  flex-wrap  p-3">
                          <div className="w-50 border-end ">
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">Site</div>
                              <div className="data-value w-70 ">
                                {detailsData?.header?.siteName}
                              </div>
                            </div>
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">Contractor</div>
                              <div className="data-value w-70 ">
                                {detailsData?.header?.contractorName || "--"}
                              </div>
                            </div>
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">Approvals</div>
                              <div className="data-value w-70 ">
                                {detailsData?.approvals && (
                                  <ApprovalTimelineContent />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="w-50 paddingLeft10">
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">
                                Creation Date
                              </div>
                              <div className="data-value w-70 ">
                                {dayjs(detailsData?.header?.createdAt).format(
                                  "DD-MMM-YYYY"
                                )}
                              </div>
                            </div>
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">Created By</div>
                              <div className="data-value w-70 ">
                                {detailsData?.header?.createdUserName}
                              </div>
                            </div>
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">
                                Is Chargeable
                              </div>
                              <div className="data-value w-70 ">
                                {detailsData?.header?.isChargeable !== null &&
                                  detailsData?.header?.isChargeable !== undefined
                                  ? detailsData?.header?.isChargeable ===
                                    true ||
                                    detailsData?.header?.isChargeable === "true"
                                    ? "Yes"
                                    : "No"
                                  : "--"}
                              </div>
                            </div>
                          </div>
                        </Col>
                      </div>
                    </Panel>
                    <Panel header="Material Information" key="2">
                      <div className="table-responsive poTable">
                        <div
                          style={{
                            width: screenSize - 350 + "px",
                            margin: "0px auto 15px auto",
                          }}
                        >
                          <Table
                            className="customTable"
                            columns={columnData}
                            dataSource={detailsData?.lines?.map(
                              (item: any) => ({
                                ...item,
                                key: item?.issueLineId,
                              })
                            )}
                            scroll={{ x: 1000 }}
                            bordered
                            size="middle"
                            pagination={false}
                            expandable={{
                              expandedRowRender: (record: any) => (
                                <MaterialTaskPanel
                                  tasks={
                                    Array.isArray(record?.materialIssueTasks)
                                      ? record.materialIssueTasks
                                      : []
                                  }
                                  readOnly
                                />
                              ),
                              rowExpandable: () => true,
                            }}
                          />
                        </div>
                      </div>
                    </Panel>
                  </AntCollapse>
                  {showCropModel && (
                    <CropperComponent
                      modal={showCropModel}
                      toggle={() => setShowCropModel(!showCropModel)}
                      onSave={(data: string) => {
                        setSignature((pre: any) => {
                          return { ...pre, image: data };
                        });
                        setShowCropModel(false);
                      }}
                    />
                  )}
                  {showSignatureModel && (
                    <SignatureModal
                      modal={showSignatureModel}
                      toggle={() => setShowSignatureModel(!showSignatureModel)}
                      onSave={(data: string) => {
                        setSignature((pre: any) => {
                          return { ...pre, image: data };
                        });
                        setShowSignatureModel(false);
                      }}
                    />
                  )}
                  <AntModal
                    title="Reject Budget"
                    visible={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    okText="Submit"
                    cancelText="Cancel"
                  >
                    <Form form={form} layout="vertical" name="rejectForm">
                      <Form.Item
                        name="reason"
                        label="Reason for Rejection"
                        rules={[
                          {
                            required: true,
                            message: "Please input your reason!",
                          },
                        ]}
                      >
                        <Input.TextArea placeholder="Type your reason here..." />
                      </Form.Item>
                    </Form>
                  </AntModal>
                </div>
              </div>
            )}
          </div>
        </Card>
      </Content>

      {/* Approve Modal with Signature */}
      <AntModal
        title="Approve Material Issue"
        visible={isModalApproveVisible}
        onOk={handleApproveWithSignature}
        onCancel={() => {
          setIsModalApproveVisible(false);
          setApproveSignature({ isActive: false, label: "Authorised Signatory", image: null });
          setDisableApprove(false);
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>
          </div>

          {approveSignature.image ? (
            <>
              <div
                className="border mb-3 d-flex justify-content-center align-items-center"
                style={{
                  padding: 16,
                  borderRadius: 8,
                  background: "#fff",
                }}
              >
                <img
                  src={approveSignature.image}
                  alt="Signed"
                  style={{ maxWidth: 220, maxHeight: 120, objectFit: "contain" }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  onClick={() =>
                    setApproveSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                >
                  Reset
                </Button>
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: 220,
                border: "2px dashed #dee2e6",
                borderRadius: 8,
                backgroundColor: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <ImageUploadCropper
                  onOpenCrop={() => {
                    setIsModalApproveVisible(false);
                  }}
                  onCloseCrop={() => {
                    if (activeSignatureContext === "APPROVE") {
                      setIsModalApproveVisible(true);
                      setDisableApprove(false);
                    } else if (activeSignatureContext === "REJECT") {
                      setIsModalRejectedVisible(true);
                      setDisableReject(false);
                    }
                  }}
                  onSave={(data: string) => {
                    if (activeSignatureContext === "APPROVE") {
                      setApproveSignature((prev: any) => ({ ...prev, image: data }));
                      setDisableApprove(false);
                    } else if (activeSignatureContext === "REJECT") {
                      setRejectSignature((prev: any) => ({ ...prev, image: data }));
                      setDisableReject(false);
                    }
                  }}
                >
                  <Button
                    color="primary"
                    size="sm"
                    outline
                    style={{ minWidth: 140 }}
                    onClick={() => setActiveSignatureContext("APPROVE")}
                  >
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  style={{ minWidth: 140 }}
                  onClick={() => {
                    setIsModalApproveVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </div>
      </AntModal>

      {/* Reject Modal with Signature */}
      <AntModal
        title="Reject Material Issue"
        visible={isModalRejectedVisible}
        onOk={() => {
          rejectForm.validateFields()
            .then((values: any) => {
              const reason = values.rejectionReason;
              handleRejectWithSignature(reason);
            })
            .catch((info: any) => {
              console.log('Validate Failed:', info);
            });
        }}
        onCancel={() => {
          setIsModalRejectedVisible(false);
          setRejectSignature({ isActive: false, label: "Authorised Signatory", image: null });
          rejectForm.resetFields();
          setDisableReject(false);
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <div className="p-3">
          <Form layout="vertical" form={rejectForm}>
            <Form.Item
              name="rejectionReason"
              label="Reason for Rejection"
              rules={[{ required: true, message: 'Please provide a reason for rejection' }]}
            >
              <Input.TextArea
                rows={3}
                placeholder="Enter reason for rejection..."
                maxLength={500}
                showCount
              />
            </Form.Item>
          </Form>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>

            {rejectSignature.image && (
              <button
                type="button"
                onClick={() =>
                  setRejectSignature({
                    isActive: true,
                    label: "Authorised Signatory",
                    image: null,
                  })
                }
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
                <EditOutlined style={{ color: "#2263b3" }} />
              </button>
            )}
          </div>

          {rejectSignature.image ? (
            <>
              <div
                className="border mb-3 d-flex justify-content-center align-items-center"
                style={{
                  padding: 16,
                  borderRadius: 8,
                  background: "#fff",
                }}
              >
                <img
                  src={rejectSignature.image}
                  alt="Signed"
                  style={{ maxWidth: 220, maxHeight: 120, objectFit: "contain" }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  onClick={() =>
                    setRejectSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                >
                  Reset
                </Button>
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: 220,
                border: "2px dashed #dee2e6",
                borderRadius: 8,
                backgroundColor: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <ImageUploadCropper
                  onOpenCrop={() => {
                    setIsModalRejectedVisible(false);
                    setActiveSignatureContext("REJECT");
                  }}
                  onCloseCrop={() => {
                    if (activeSignatureContext === "APPROVE") {
                      setIsModalApproveVisible(true);
                      setDisableApprove(false);
                    } else if (activeSignatureContext === "REJECT") {
                      setIsModalRejectedVisible(true);
                      setDisableReject(false);
                    }
                  }}
                  onSave={(data: string) => {
                    if (activeSignatureContext === "APPROVE") {
                      setApproveSignature((prev: any) => ({ ...prev, image: data }));
                      setDisableApprove(false);
                    } else if (activeSignatureContext === "REJECT") {
                      setRejectSignature((prev: any) => ({ ...prev, image: data }));
                      setDisableReject(false);
                    }
                  }}
                >
                  <Button
                    color="primary"
                    size="sm"
                    outline
                    style={{ minWidth: 140 }}
                    onClick={() => setActiveSignatureContext("REJECT")}
                  >
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  style={{ minWidth: 140 }}
                  onClick={() => {
                    setIsModalRejectedVisible(false);
                    setShowSignatureModel(true);
                    setActiveSignatureContext("REJECT");
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </div>
      </AntModal>

      {/* Signature Modal */}
      {showSignatureModel && (
        <SignatureModal
          modal={showSignatureModel}
          toggle={() => {
            setShowSignatureModel(false);
            if (activeSignatureContext === "APPROVE") {
              setIsModalApproveVisible(true);
              setDisableApprove(false);
            } else if (activeSignatureContext === "REJECT") {
              setIsModalRejectedVisible(true);
              setDisableReject(false);
            }
          }}
          onSave={(data: string) => {
            if (activeSignatureContext === "APPROVE") {
              setApproveSignature((prev: any) => ({ ...prev, image: data }));
              setIsModalApproveVisible(true);
              setDisableApprove(false);
            } else if (activeSignatureContext === "REJECT") {
              setRejectSignature((prev: any) => ({ ...prev, image: data }));
              setIsModalRejectedVisible(true);
              setDisableReject(false);
            }
            setShowSignatureModel(false);
          }}
        />
      )}

    </>
  );
};

export default MaterialDetails;
